import Container from './Container';
import Item from './Item';

export default {
  Container,
  Item,
};



// WEBPACK FOOTER //
// ../ui-components/components/Tab/index.jsx